<div class="link-container" routerLinkActive="active" [routerLinkActiveOptions]="{ exact: true }">

  <section class="line"></section>

  <a href="#" class="no-underline pl-[28px]" [routerLink]="[route]">
    <ng-content></ng-content>
  </a>
</div>